<div class="m-0 md:ml-8 mt-2 md:mt-0" >
  <label>
    Date:
    <p-datepicker
      class="date-input"
      inputStyleClass="text-box"
      [(ngModel)]="selectedCalendarDate"
      (ngModelChange)="updateCurrentDate()"
      [name]="this.currentQuestion.GUID + 'date'"
      dateFormat="dd M yy"
      [showIcon]="false"
    ></p-datepicker>
  </label>
</div>
<div class="m-0 md:ml-8 mt-2">
  <button type="button" class="text-sm text-grey-700 underline underline-offset-2 hover:text-green-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-green-700 rounded-sm"
    (click)="setCurrentLocalDate()" aria-label="Set the current local date">
    Set to current date
  </button>
</div>
